/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Room_Association_Dialog_SubtitleInputs */



/**
* | output |
* | --- |
* | "Edit room/AHU associations" |
*
* @param {Air_Handler_Unit_Room_Association_Dialog_SubtitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_room_association_dialog_subtitle = /** @type {((inputs?: Air_Handler_Unit_Room_Association_Dialog_SubtitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Room_Association_Dialog_SubtitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Edit room/AHU associations")
	return /** @type {LocalizedString} */ ("Modifier les associations pièce/CTA")
});